export default __webpack_public_path__ + "static/media/header_cover_mobile.a834f059.png";